"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            padding: spacing(2),
            width: function (_a) {
                var width = _a.width;
                return (width || spacing(45));
            }
        }
    });
});
exports.default = useStyles;
